export default __webpack_public_path__ + "static/media/Hover.1ec8a87f.svg";